import { useEffect, useState } from 'react'
import { joinedWinningCombination } from './drawCombination'
export default function useWinCombinations(
  state: number,
  player: string[],
  dealer: string[],
  playerType: number,
  dealerType: number,
) {
  const empty = ['0', '0', '0', '0', '0', '0', '0', '0', '0']
  const [winCombination, setWinCombination] = useState<string[]>(empty)
  const [winType, setWinType] = useState<number>(0)

  useEffect(() => {
    if (state === 4 || state === 5 || state === 14 || state === 15) {
      setWinCombination(player)
      setWinType(playerType)
    } else if (state === 6 && dealer[0] !== 'X0') {
      setWinCombination(dealer)
      setWinType(dealerType)
    } else if (state === 11) {
      setWinCombination(
        joinedWinningCombination(player, dealer)
      )
      setWinType(playerType)
    } else {
      setWinCombination(empty)
      setWinType(0)
    }
  }, [state, player, dealer, playerType, dealerType])

  return { winCombination, winType }
}
